
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./TEGReboiler.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { AirCoolerContext } from "../context/AirCoolerContext";
import AirCooler from "../components/AirCooler";
import AirCoolerFaceplate from "../components/AirCoolerFaceplate";

import { trackPageVisit } from "../competency/PageTracker";







 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


              function AirCoolerPage() {
                const [openPanels, setOpenPanels] = useState([]);

                const openPanel = (tag) => {
                  setOpenPanels((prev) =>
                    prev.includes(tag) ? prev : [...prev, tag]
                  );
                };

                const closePanel = (tag) => {
                  setOpenPanels((prev) => prev.filter((p) => p !== tag));
                };

                return (
                  <div>
                    <AirCooler tag="M-2701AA" x={300} y={200} onClick={openPanel} />
                    <AirCooler tag="M-2701AB" x={500} y={200} onClick={openPanel} />
                    <AirCooler tag="M-2701BA" x={300} y={200} onClick={openPanel} />
                    <AirCooler tag="M-2701BB" x={500} y={200} onClick={openPanel} />

                    {openPanels.map((tag, i) => (
                      <AirCoolerFaceplate
                        key={tag}
                        tag={tag}
                        close={() => closePanel(tag)}
                        defaultPosition={{ x: 300 + i * 40, y: 120 + i * 40 }}
                      />
                    ))}
                  </div>
                );
              }


function TEGReboiler() {

        useEffect(() => {
  
    trackPageVisit("TEGReboiler");
  
  }, []);

  const {  valves, toggleValve, transmitters} = useContext(WellContext);
  const { pumpData } = useContext(PumpContext);
  const { airCoolerData } = useContext(AirCoolerContext);       
  const { levels } = useContext(WellContext);





  


  const DEFAULT_VALVES = {
  PCV_2701: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_2701: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_2702: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_2703: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2701: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_2702: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("TEGReboiler_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      PCV_2701: { ...DEFAULT_VALVES.PCV_2701, ...parsed.PCV_2701 },
      LCV_2701: { ...DEFAULT_VALVES.LCV_2701, ...parsed.LCV_2701 },
      LCV_2702: { ...DEFAULT_VALVES.LCV_2702, ...parsed.LCV_2702 },
      LCV_2703: { ...DEFAULT_VALVES.LCV_2703, ...parsed.LCV_2703 },
      FCV_2701: { ...DEFAULT_VALVES.LCV_2701, ...parsed.LCV_2701 },
      FCV_2702: { ...DEFAULT_VALVES.FCV_2702, ...parsed.FCV_2702 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("TEGReboiler_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };




  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};



const [openCoolerPanels, setOpenCoolerPanels] = useState([]);

const openCoolerPanel = (tag) => {
  setOpenCoolerPanels((prev) =>
    prev.includes(tag) ? prev : [...prev, tag]
  );
};

const closeCoolerPanel = (tag) => {
  setOpenCoolerPanels((prev) => prev.filter((p) => p !== tag));
};





  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
   
  const [FIC_2308, setFIC_2308] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2308")) || 0;
            setFIC_2308(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [PT_2305, setPT_2305] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("PT_2305")) || 0;
            setPT_2305(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [TT_2307, setTT_2307] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("TT_2307")) || 0;
            setTT_2307(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


        
  /* ================= VALVE STATUS ================= 

  const isXV2701Open = valves?.XV_2701 === false;
  const isXV2702Open = valves?.XV_2702 === false;
  const isXV2703Closed = valves?.XV_2703 === true;
  const isXV2703Open = valves?.XV_2703 === false;  
  const isXV2704Open = valves?.XV_2704 === false;
  const isXV2705Open = valves?.XV_2705 === false;

*/

const TT_2701 = TT_2307;

const PT_2703 = PT_2305;

const FIC_2702 = FIC_2308;

// ======================================================
// BBC 0500 BTU/HR TEG REBOILER UNIT
// ======================================================

// ====================================================
// REBOILER STATE (PERSISTENT)
// ====================================================

const [reboilerOn, setReboilerOn] = useState(() => {
  return localStorage.getItem("TEG_REBOILER_ON") === "true";
});

// ====================================================
// TEMPERATURE (PERSISTENT)
// ====================================================

const [TT_2705, setTT_2705] = useState(() => {
  const savedTemp = localStorage.getItem("TT_2705");

  return savedTemp
    ? Number(savedTemp)
    : 30;
});

// ====================================================
// COIL INTENSITY (PERSISTENT)
// ====================================================

const [coilIntensity, setCoilIntensity] = useState(() => {
  const savedGlow =
    localStorage.getItem("TEG_COIL_INTENSITY");

  return savedGlow
    ? Number(savedGlow)
    : 0;
});

// ====================================================
// SAVE REBOILER STATE
// ====================================================

useEffect(() => {

  localStorage.setItem(
    "TEG_REBOILER_ON",
    reboilerOn
  );

}, [reboilerOn]);

// ====================================================
// SAVE TEMPERATURE
// ====================================================

useEffect(() => {

  localStorage.setItem(
    "TT_2705",
    TT_2705
  );

}, [TT_2705]);

// ====================================================
// SAVE COIL INTENSITY
// ====================================================

useEffect(() => {

  localStorage.setItem(
    "TEG_COIL_INTENSITY",
    coilIntensity
  );

}, [coilIntensity]);

// ====================================================
// REBOILER ENGINE
// ====================================================

useEffect(() => {

  const interval = setInterval(() => {

    // ================================================
    // HEATING MODE
    // ================================================

    if (reboilerOn) {

      // ============================================
      // TEMPERATURE RAMP
      // ============================================

      setTT_2705(prev => {

        let next = prev;

        // HEATING UP
        if (prev < 203.5) {

          next = prev + 1.8;
        }

        // STABILIZE AROUND 204
        else {

          next =
            204 +
            ((Math.random() * 1.6) - 0.8);
        }

        return Number(next.toFixed(2));
      });

      // ============================================
      // COIL GLOW
      // ============================================

      setCoilIntensity(prev => {

        let next = prev + 6;

        if (next > 255)
          next = 255;

        return next;
      });
    }

    // ================================================
    // COOLING MODE
    // ================================================

    else {

      setTT_2705(prev => {

        let next = prev - 1.2;

        if (next < 30)
          next = 30;

        return Number(next.toFixed(2));
      });

      setCoilIntensity(prev => {

        let next = prev - 8;

        if (next < 0)
          next = 0;

        return next;
      });
    }

  }, 1000);

  return () => clearInterval(interval);

}, [reboilerOn]);

// ====================================================
// DYNAMIC COIL COLOR
// ====================================================

const coilColor = `rgb(
  255,
  ${255 - coilIntensity},
  ${255 - coilIntensity}
)`;



// ======================================================
// TEG REBOILER HEATING EFFECT
// TT_2701 → Heated by Reboiler → TT_2702
// ======================================================

/*
  TT_2701:
  Incoming TEG temperature
  Usually around 30–40°C

  TT_2705:
  Reboiler temperature
  30–204°C

  TT_2702:
  Heated outlet TEG temperature
*/

// ======================================================
// OUTPUT VARIABLE
// ======================================================

let TT_2702 = TT_2701;

// ======================================================
// NORMALIZED REBOILER HEAT
// ======================================================

/*
  Converts:
  30°C  → 0
  204°C → 1
*/

const reboilerRatio =

  (TT_2705 - 30) /

  (204 - 30);

// ======================================================
// LIMIT RATIO
// ======================================================

const limitedRatio =

  Math.max(
    0,
    Math.min(reboilerRatio, 1)
  );

// ======================================================
// TARGET HEATING EFFECT
// ======================================================

/*
  Maximum heating rise:
  About +10°C

  Example:
  TT_2701 = 30
  TT_2705 = 204

  TT_2702 ≈ 40
*/

const heatingRise =
  limitedRatio * 10;

// ======================================================
// HEATED TEG OUTLET
// ======================================================

TT_2702 =
  TT_2701 + heatingRise;

// ======================================================
// SMALL PROCESS FLUCTUATION
// ======================================================

TT_2702 +=
  (Math.random() * 0.4) - 0.2;

// ======================================================
// SAFETY LIMITS
// ======================================================

if (TT_2702 < TT_2701)
  TT_2702 = TT_2701;

if (TT_2702 > 40)
  TT_2702 = 40;








// ======================================================
// 2-STAGE LEAN/RICH TEG HEAT EXCHANGER
// CORRECTED REALISTIC THERMAL MODEL
// ======================================================

/*
  PROCESS LOGIC

  HOT SIDE:
  TT_2705  → STAGE 1 → TT_2707 → STAGE 2 → TT_2709

  COLD SIDE:
  TT_2701 → TT_2702 → STAGE 2 → TT_27010 → STAGE 1 → TT_2703

  IMPORTANT CORRECTION:
  IF TT_2705 DROPS TO ~30°C
  THEN HEAT EXCHANGE EFFECTIVELY STOPS

  Therefore:

  TT_2707  ≈ TT_2705
  TT_2709  ≈ TT_2707
  TT_2702  ≈ TT_2701
  TT_27010 ≈ TT_2702
  TT_2703  ≈ TT_27010
*/

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let TT_2707 = TT_2705;

let TT_2709 = TT_2705;

let TT_27010 = TT_2702;

let TT_2703 = TT_2702;

// ======================================================
// AVAILABLE HEAT ABOVE AMBIENT
// ======================================================

const availableHeat =
  Math.max(TT_2705 - 30, 0);

// ======================================================
// NORMAL HEAT EXCHANGING
// ======================================================

if (availableHeat > 0) {

  // ====================================================
  // HEAT EXCHANGER EFFECTIVENESS
  // ====================================================

  /*
    0 at 30°C
    1 at 204°C
  */

  const exchangerEfficiency =
    Math.min(
      availableHeat / (204 - 30),
      1
    );

  // ====================================================
  // STAGE 1
  // TT_2705 HEATS TT_27010
  // ====================================================

  /*
    HOT SIDE COOLS:
    204 → ~160

    COLD SIDE WARMS:
    ~60 → ~100
  */

  const stage1HotDrop =
    44 * exchangerEfficiency;

  TT_2707 =
    TT_2705 - stage1HotDrop;

  // ====================================================
  // STAGE 2
  // TT_2707 HEATS TT_2702
  // ====================================================

  /*
    HOT SIDE:
    ~160 → ~60

    COLD SIDE:
    ~40 → ~60
  */

  const stage2ColdRise =
    20 * exchangerEfficiency;

  TT_27010 =
    TT_2702 + stage2ColdRise;

  // ====================================================
  // FINAL HOT OUTLET
  // ====================================================

  const stage2HotDrop =
    100 * exchangerEfficiency;

  TT_2709 =
    TT_2707 - stage2HotDrop;

  // ====================================================
  // FINAL LEAN TEG TEMP
  // STAGE 1 HEATING
  // ====================================================

  const finalLeanRise =
    40 * exchangerEfficiency;

  TT_2703 =
    TT_27010 + finalLeanRise * 2.5;

  // ====================================================
  // SAFETY LIMITS
  // ====================================================

  if (TT_2707 < 30)
    TT_2707 = 30;

  if (TT_2709 < 30)
    TT_2709 = 30;

  if (TT_27010 < TT_2702)
    TT_27010 = TT_2702;

  if (TT_2703 < TT_27010)
    TT_2703 = TT_27010;
}

// ======================================================
// NO HEAT EXCHANGE CONDITION
// ======================================================

else {

  /*
    Reboiler cold
    =
    no heat transfer
  */

  TT_2707 =
    TT_2705;

  TT_2709 =
    TT_2707;

  TT_2702 =
    TT_2701;

  TT_27010 =
    TT_2702 * (valveData?.LCV_2703?.opening || 0)/70;

  TT_2703 =
    TT_27010;
}



  const TT_2708 = TT_2709;

  const PT_2701 = PT_2703 * (valveData?.PCV_2701?.opening || 0)/1850

  const PT_2702 = PT_2701 * 1.0998;








  // ======================================================
// TEG CIRCULATION PUMPS P-2701 A/B
// ======================================================

/*
  SUCTION:
  --------
  PT_2702
  TT_2709

  DISCHARGE:
  ----------
  PT_2704
  FIC_2704
  TT_500

  CONTROL:
  --------
  FCV_2701
*/

// ======================================================
// PUMP STATUS
// ======================================================

const pump2701A_Running =
  pumpData?.["P-2701A"]?.running ?? false;

const pump2701B_Running =
  pumpData?.["P-2701B"]?.running ?? false;

// ======================================================
// AT LEAST ONE PUMP RUNNING
// ======================================================

const tegPumpRunning =

  pump2701A_Running ||

  pump2701B_Running;

// ======================================================
// CONTROL VALVE OPENING
// ======================================================

const FCV_2701_OPENING =

  (valveData?.FCV_2701?.opening || 0) / 100;

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let PT_2704 = 0.03;

let FIC_2704 = 0;

let TT_500 = TT_2709;

// ======================================================
// PUMP OFF CONDITION
// ======================================================

if (!tegPumpRunning) {

  PT_2704 = PT_2702;

  FIC_2704 = 0;

  TT_500 = TT_2709;
}

// ======================================================
// PUMP RUNNING
// ======================================================

else {

  // ====================================================
  // VALVE FULLY CLOSED
  // DEADHEAD CONDITION
  // ====================================================

  if (FCV_2701_OPENING <= 0.01) {

    /*
      Pump develops pressure
      but almost no flow
    */

    PT_2704 =
      4.2 + (Math.random() * 0.15);

    FIC_2704 =
      0.02 + (Math.random() * 0.03);

    /*
      Slight heating due to recirculation
    */

    TT_500 =
      TT_2709 + 2.5;
  }

  // ====================================================
  // NORMAL FLOWING CONDITION
  // ====================================================

  else {

    // ==================================================
    // FLOW CHARACTERISTIC
    // ==================================================

    /*
      At 60% opening:
      FIC ≈ 24
    */

    FIC_2704 =

      FCV_2701_OPENING * 40;

    // ==================================================
    // SMALL FLOW LOSSES
    // ==================================================

    FIC_2704 *= 0.995;

    // ==================================================
    // DISCHARGE PRESSURE
    // ==================================================

    /*
      More valve opening
      =
      less backpressure
    */

    PT_2704 =

      5.2 -

      (FCV_2701_OPENING * 3);

    /*
      At 60%:
      5.2 - 1.8 ≈ 3.4 MPa
    */

    // ==================================================
    // TEMPERATURE EFFECT
    // ==================================================

    /*
      Minor heating effect
      from pumping/friction
    */

    TT_500 =

      TT_2709 +

      (FCV_2701_OPENING * 0.8);

    // ==================================================
    // PROCESS FLUCTUATIONS
    // ==================================================

    PT_2704 +=
      (Math.random() * 0.08) - 0.04;

    FIC_2704 +=
      (Math.random() * 0.4) - 0.2;

    TT_500 +=
      (Math.random() * 0.3) - 0.15;
  }
}

// ======================================================
// LIMITS
// ======================================================

if (FIC_2704 < 0)
  FIC_2704 = 0;

if (PT_2704 < 0.03)
  PT_2704 = 0.03;

// ======================================================
// STORAGE
// ======================================================

localStorage.setItem(
  "PT_2704",
  PT_2704
);

localStorage.setItem(
  "FIC_2704",
  FIC_2704
);

localStorage.setItem(
  "TT_500",
  TT_500
);

  
const FIC_2703 = 40.322 * (valveData?.LCV_2702?.opening || 0)/100;

const TT_2704 = TT_2703 * 0.987;
















// ======================================================
// SIMPLE AIR COOLER MODEL (STABLE + DIRECT)
// ======================================================

const M2701AA = airCoolerData?.["M-2701AA"] || { speed: 0, running: false };
const M2701AB = airCoolerData?.["M-2701AB"] || { speed: 0, running: false };
const M2701BA = airCoolerData?.["M-2701BA"] || { speed: 0, running: false };
const M2701BB = airCoolerData?.["M-2701BB"] || { speed: 0, running: false };

// ======================================================
// COUNT RUNNING FANS
// ======================================================

const runningFans = [
  M2701AA.running,
  M2701AB.running,
  M2701BA.running,
  M2701BB.running
].filter(Boolean).length;



// ======================================================
// INPUT TEMPERATURE
// ======================================================

const inletTemp = Number(TT_2704 ?? 0);

// ======================================================
// OUTPUT
// ======================================================

let TT_2706 = inletTemp;

// ======================================================
// SIMPLE LINEAR COOLING MODEL
// ======================================================

if (runningFans === 0) {

  // no cooling, slight drift
  TT_2706 = inletTemp + (Math.random() * 0.6 - 0.3);

} else {

  // fraction of cooling capacity
  const coolingFraction = runningFans / 4;

  // base ambient floor (important realism)
  const ambient = 32;

  // max possible cooling range
  const maxDrop = inletTemp - ambient;

  // actual cooling applied
  const appliedDrop = maxDrop * coolingFraction;

  TT_2706 = inletTemp - appliedDrop;

  // small realism noise
  TT_2706 += (Math.random() * 0.5 - 0.25);
}

// ======================================================
// SAFETY LIMITS
// ======================================================

// cannot go below ambient
if (TT_2706 < 32) TT_2706 = 32;

// cannot exceed inlet
if (TT_2706 > inletTemp) TT_2706 = inletTemp;

// ======================================================
// FINAL OUTPUT
// ======================================================

TT_2706 = Number(TT_2706.toFixed(1));






// ======================================================
// SIMPLE LOAD-SHARING LOGIC
// P-2702 A/B
// ======================================================

// TOTAL REQUIRED FLOW
const TOTAL_FLOW = 30.23;

// ======================================================
// PUMP STATUS
// ======================================================

const P2702A_RUNNING =
  pumpData?.["P-2702A"]?.running ?? false;

const P2702B_RUNNING =
  pumpData?.["P-2702B"]?.running ?? false;

// ======================================================
// OUTPUT VARIABLES
// ======================================================

let FIC_27020 = 0;

let FLOW_P2702A = 0;
let FLOW_P2702B = 0;

let PT_27020 = 0.03;

// ======================================================
// BOTH PUMPS OFF
// ======================================================

if (
  !P2702A_RUNNING &&
  !P2702B_RUNNING
) {

  FIC_27020 = 0;

  FLOW_P2702A = 0;
  FLOW_P2702B = 0;

  PT_27020 = 0.03;
}

// ======================================================
// ONLY PUMP A RUNNING
// ======================================================

else if (
  P2702A_RUNNING &&
  !P2702B_RUNNING
) {

  FLOW_P2702A =
    TOTAL_FLOW +
    ((Math.random() * 0.6) - 0.3);

  FLOW_P2702B = 0;

  FIC_27020 = FLOW_P2702A;

  PT_27020 =
    3.8 +
    ((Math.random() * 0.1) - 0.05);
}

// ======================================================
// ONLY PUMP B RUNNING
// ======================================================

else if (
  !P2702A_RUNNING &&
  P2702B_RUNNING
) {

  FLOW_P2702B =
    TOTAL_FLOW +
    ((Math.random() * 0.6) - 0.3);

  FLOW_P2702A = 0;

  FIC_27020 = FLOW_P2702B;

  PT_27020 =
    3.8 +
    ((Math.random() * 0.1) - 0.05);
}

// ======================================================
// BOTH PUMPS RUNNING
// LOAD SHARING
// ======================================================

else {

  FLOW_P2702A =
    (TOTAL_FLOW / 2) +
    ((Math.random() * 0.4) - 0.2);

  FLOW_P2702B =
    (TOTAL_FLOW / 2) +
    ((Math.random() * 0.4) - 0.2);

  FIC_27020 =
    FLOW_P2702A +
    FLOW_P2702B;

  PT_27020 =
    4.2 +
    ((Math.random() * 0.1) - 0.05);
}







          useEffect(() => {
            localStorage.setItem("TT_500", TT_500);
          }, [TT_500]);


          useEffect(() => {
            localStorage.setItem("PT_2704", PT_2704);
          }, [PT_2704]);






  return (
    <div className="TEGReboiler-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "2px",
        left: "196px",
        color: "white",
        background: "rgba(32, 8, 245, 0.99)",
        padding: "2px 320px"
      }}>
        TEG REGENERATION UNIT
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2701 
      <Valve
        className="XV-2701"
        tag="XV_2701"
        x={710}
        y={319}
        isClosed={valves.XV_2701}
        toggle={toggleValve}
      />
      */}
      


      
        {/* ================= CONTROL VALVES SVG ================= */}
        

        
         {/* PCV-2701 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="PCV-2701"
          style={{ position: "absolute", left: 605, top: 235, transform: "rotate(270deg)", transformOrigin: "center"}}  onClick={() => openPanel("PCV_2701")}>
          
          <defs>
            <linearGradient id="metal_2701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* LCV-2701 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="LCV-2701"
          style={{ position: "absolute", left: 870, top: 339}}  onClick={() => openPanel("LCV_2701")}>
          
          <defs>
            <linearGradient id="metal_2701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* LCV-2702 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="LCV-2702"
          style={{ position: "absolute", left: 650, top: 541}}  onClick={() => openPanel("LCV_2702")}>
          
          <defs>
            <linearGradient id="metal_2702">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* LCV-2703 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="LCV-2703"
          style={{ position: "absolute", left: 875, top: 556, transform: "rotate(90deg)", transformOrigin: "center"}}  onClick={() => openPanel("LCV_2703")}>
          
          <defs>
            <linearGradient id="metal_2703">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2703)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2703)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* FCV-2701 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="FCV-2701"
          style={{ position: "absolute", left: 473, top: 774}}  onClick={() => openPanel("FCV_2701")}>
          
          <defs>
            <linearGradient id="metal_2701">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2701)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>

         {/* FCV-2702 */}
        <svg width="80" height="50" viewBox="0 0 250 225" className="FCV-2702"
          style={{ position: "absolute", left: 403, top: 494}}  onClick={() => openPanel("FCV_2702")}>
          
          <defs>
            <linearGradient id="metal_2702">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>

          <path d="M25 60 A80 60 0 0 1 180 60 L180 90 L25 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="25,250 100,150 25,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,250 100,150 180,110"
            fill="url(#metal_2702)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>


          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 270 + index * 40
              }}
            />
          ))}

          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          {/* ================= ✅ AIR COOLER FACEPLATES ================= */}
          {openCoolerPanels.map((tag, index) => (
            <AirCoolerFaceplate
              key={tag}
              tag={tag}
              close={() => closeCoolerPanel(tag)}
              defaultPosition={{
                x: 400 + index * 40,
                y: 200 + index * 40
              }}
            />
          ))}

      
      
      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.PCV_2701?.opening || 0)}
        x={660}
        y={256}
      />

      <ValveOutput
        value={Number(valveData?.LCV_2701?.opening || 0)}
        x={891}
        y={381}
      />

      <ValveOutput
        value={Number(valveData?.LCV_2702?.opening || 0)}
        x={674}
        y={586}
      />

      <ValveOutput
        value={Number(valveData?.LCV_2703?.opening || 0)}
        x={870}
        y={567}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2701?.opening || 0)}
        x={493}
        y={818}
      />

      <ValveOutput
        value={Number(valveData?.FCV_2702?.opening || 0)}
        x={425}
        y={548}
      />



          <Transmitter
            tag="FIC-2702"
            value={[FIC_2702]}
            x={503}
            y={70}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF RICH TEG FROM BOTTOM OF TEG CONTACTOR AT THE DISCHARGE TEG REBOILER CONVECTION ZONE"
          />

          <Transmitter
            tag="TT-2701"
            value={[TT_2701]}
            x={245}
            y={70}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF RICH TEG FROM BOTTOM OF TEG CONTACTOR TO THE INLET TEG REBOILER CONVECTION ZONE/REFLUX CONDENSER"
          />

          <Transmitter
            tag="TT-2702"
            value={[TT_2702]}
            x={442}
            y={70}
            unit="°C"
            max={100}
            HH={90}
            H={80}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF RICH TEG FROM BOTTOM OF TEG CONTACTOR TO THE DISCHARGE TEG REBOILER CONVECTION ZONE/REFLUX CONDENSER"
          />

          <Transmitter
            tag="PT-2703"
            value={[PT_2703]}
            x={741}
            y={431}
            unit="MPa"
            max={2}
            HH={1.8}
            H={1.6}
            L={0.04}
            LL={0.01}
            c="lime"
            description="PRESSURE OF RICH TEG FROM BOTTOM OF TEG CONTACTOR TO TEG REBOILER CONVECTION ZONE"
          />

          <Transmitter
            tag="PT-2701"
            value={[PT_2701]}
            x={483}
            y={132}
            unit="MPa"
            max={2}
            HH={1}
            H={0.6}
            L={0.04}
            LL={0.001}
            c="lime"
            description="PRESSURE OF RICH TEG AT THE INLET OF TEG REBOILER AFTER PRESSURE REDUCTION"
          />

          <Transmitter
            tag="PT-2702"
            value={[PT_2702]}
            x={313}
            y={302}
            unit="MPa"
            max={2}
            HH={1}
            H={0.6}
            L={0.04}
            LL={0.001}
            c="lime"
            description="PRESSURE OF LEAN TEG AT THE TEG REBOILER"
          />

          <Transmitter
            tag="TT-2705"
            value={[TT_2705]}
            x={245}
            y={304}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG INSIDE THE TEG REBOILER VESSEL"
          />

          <Transmitter
            tag="TT-2707"
            value={[TT_2707]}
            x={243}
            y={440}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG AT THE DISCHARGE OF 1 STAGE LEAN/RICH TEG HEAT EXCHANGER"
          />

          <Transmitter
            tag="TT-2708"
            value={[TT_2708]}
            x={817}
            y={431}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG AT THE DISCHARGE OF 2 STAGE LEAN/RICH TEG HEAT EXCHANGER AND LOCATED ON THE SURGE TANK"
          />

          <Transmitter
            tag="TT-2709"
            value={[TT_2709]}
            x={145}
            y={556}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG AT THE DISCHARGE OF 2 STAGE LEAN/RICH TEG HEAT EXCHANGER AFTER THE SOCKET AND CHARCOAL FILTERS"
          />

          <Transmitter
            tag="TT-27010"
            value={[TT_27010]}
            x={645}
            y={384}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF RICH TEG AT THE INLET OF 1 STAGE LEAN/RICH TEG HEAT EXCHANGER"
          />

          <Transmitter
            tag="TT-2703"
            value={[TT_2703]}
            x={378}
            y={132}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF RICH TEG AT THE DISCHARGE OF 1 STAGE LEAN/RICH TEG HEAT EXCHANGER"
          />

          <Transmitter
            tag="TT-500"
            value={[TT_500]}
            x={184}
            y={770}
            unit="°C"
            max={210}
            HH={205}
            H={205}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF LEAN TEG AT THE DISCHARGE OF TEG CIRCULATION PUMPS TO TEG CONTACTOR UNIT"
          />

          <Transmitter
            tag="PT-2704"
            value={[PT_2704]}
            x={253}
            y={770}
            unit="MPa"
            max={4}
            HH={3.8}
            H={3.5}
            L={0.4}
            LL={0.1}
            c="lime"
            description="PRESSURE OF LEAN TEG AT THE DISCHARGE OF TEG CIRCULATION PUMPS TO TEG CONTACTOR UNIT"
          />

          <Transmitter
            tag="FIC-2704"
            value={[FIC_2704]}
            x={373}
            y={770}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF LEAN TEG AT THE DISCHARGE OF TEG CIRCULATION PUMPS TO TEG CONTACTOR UNIT"
          />

          <Transmitter
            tag="FIC-2703"
            value={[FIC_2703]}
            x={568}
            y={547}
            unit="LPM"
            max={70}
            HH={80}
            H={60}
            L={5}
            LL={3}
            c="lime"
            description="FLOWRATE OF SKIMMED LIQUID HYDROCARBON FROM FLASH GAS SEPARATOR"
          />

          <Transmitter
            tag="TT-2704"
            value={[TT_2704]}
            x={604}
            y={132}
            unit="°C"
            max={180}
            HH={175}
            H={160}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF VAPORIZED LIGHTER HYDROCARBONS AT THE DISCHARGE OF REBOILER CONDENSER TO AIR COOLERS"
          />

          <Transmitter
            tag="TT-2706"
            value={[TT_2706]}
            x={928}
            y={234}
            unit="°C"
            max={180}
            HH={175}
            H={160}
            L={14}
            LL={5}
            c="lime"
            description="TEMPERATURE OF VAPORIZED LIGHTER HYDROCARBONS AT THE DISCHARGE OF REBOILER CONDENSER TO AIR COOLERS"
          />






        {/* ============================================
            REBOILER COIL
        ============================================ */}

        <svg
          width={270}
          height={60}
          style={{
            position: "absolute",
            left: 180,
            top: 220
          }}
        >

          <path
            d="
              M10 20
              Q30 20 30 40
              Q30 60 50 60
              Q70 60 70 40
              Q70 20 90 20
              Q110 20 110 40
              Q110 60 130 60
              Q150 60 150 40
              Q150 20 170 20
              Q190 20 190 40
              Q190 60 210 60
            "

            fill="none"

            stroke={coilColor}

            strokeWidth="6"

            strokeLinecap="round"

            style={{

              transition: "0.5s",

              filter:
                coilIntensity > 0

                  ? `drop-shadow(
                      0 0 ${coilIntensity / 8}px red
                    )`

                  : "none"
            }}
          />

        </svg>

        {/* ============================================
            ON/OFF BUTTON
        ============================================ */}

        <div
          onClick={() => {

                  setReboilerOn(prev => {

                    const next = !prev;

                    localStorage.setItem(
                      "TEG_REBOILER_ON",
                      next
                    );

                    return next;
                  });

                }}

          style={{

            position: "absolute",

            left: 50,
            top: 240,

            width: 48,
            height: 27,

            background:
              reboilerOn
                ? "lime"
                : "red",

            color: "black",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            fontWeight: "bold",

            border: "2px solid white",

            borderRadius: "2px",

            cursor: "pointer",

            userSelect: "none",

            boxShadow:
              reboilerOn
                ? "0 0 18px lime"
                : "0 0 12px red",

            transition: "0.4s"
          }}
        >
          {reboilerOn ? "ON" : "OFF"}
        </div>





        
    <LevelTransmitterIndicator
      tag="LT_2701"
      totalLevel={80000}
      inflows={[FIC_2702 * 0.989]}
      outflows={[FIC_2702 * (valveData?.FCV_2702?.opening || 0)/70]}
      responseFactor={0.05}
      columnX={180}
      columnY={188}
      columnWidth={303}
      columnHeight={93}
      textX={130}
      textY={99}
      showFlow={true}
      backgroundOpacity={0.03}
      liquidOpacity={0.3}
    />

    <LevelTransmitterIndicator
      tag="LT_2702"
      totalLevel={130000}
      inflows={[FIC_2702 * (valveData?.FCV_2702?.opening || 0)/100]}
      outflows={[FIC_2704]}
      responseFactor={0.05}
      columnX={98}
      columnY={584}
      columnWidth={187}
      columnHeight={76}
      textX={315}
      textY={569}
      showFlow={true}
      backgroundOpacity={0.03}
      liquidOpacity={0.3}
    />

    <LevelTransmitterIndicator
      tag="LT_2703"
      totalLevel={130000}
      inflows={[FIC_2702 * 0.989]}
      outflows={[FIC_2702 * (valveData?.LCV_2703?.opening || 0)/70]}
      responseFactor={0.05}
      columnX={737}
      columnY={452}
      columnWidth={176}
      columnHeight={56}
      textX={945}
      textY={429}
      showFlow={true}
      backgroundOpacity={0.03}
      liquidOpacity={0.3}
    />

    <LevelTransmitterIndicator
      tag="LT_2704"
      totalLevel={130000}
      inflows={[FIC_2702 * 0.989]}
      outflows={[FIC_2703 * (valveData?.LCV_2702?.opening || 0)/70]}
      responseFactor={0.05}
      columnX={747}
      columnY={462}
      columnWidth={60}
      columnHeight={36}
      textX={785}
      textY={529}
      showFlow={true}
      backgroundOpacity={0.03}
      liquidOpacity={0.8}
    />

    <LevelTransmitterIndicator
      tag="LT_2705"
      totalLevel={130000}
      inflows={[TT_2706 * 0.19]}
      outflows={[FIC_27020]}
      responseFactor={0.05}
      columnX={1007}
      columnY={293}
      columnWidth={115}
      columnHeight={59}
      textX={1195}
      textY={279}
      showFlow={true}
      backgroundOpacity={0.03}
      liquidOpacity={0.8}
    />





        <Pump
          tag="P-2701A"
          x={588}
          y={725}
          rpm={1800}
          bladeCount={pumpData?.["P-2701A"]?.bladeCount || 6}
          size={pumpData?.["P-2701A"]?.size || 48}
          onClick={openPumpPanel}
        />

        <Pump
          tag="P-2701B"
          x={695}
          y={723}
          rpm={1800}
          bladeCount={pumpData?.["P-2701B"]?.bladeCount || 6}
          size={pumpData?.["P-2701B"]?.size || 48}
          onClick={openPumpPanel}
        />

        <Pump
          tag="P-2702A"
          x={1134}
          y={403}
          rpm={1800}
          bladeCount={pumpData?.["P-2702A"]?.bladeCount || 6}
          size={pumpData?.["P-2702A"]?.size || 48}
          onClick={openPumpPanel}
        />

        <Pump
          tag="P-2702B"
          x={1207}
          y={403}
          rpm={1800}
          bladeCount={pumpData?.["P-2702B"]?.bladeCount || 6}
          size={pumpData?.["P-2702B"]?.size || 48}
          onClick={openPumpPanel}
        />


        <AirCooler
          tag="M-2701AA"
          x={775}
          y={170}
          rpm={1500}
          size={45}
          bladeCount={7}
          bladeLength={30}
        onClick={() => openCoolerPanel("M-2701AA")}    />
      
     
        <AirCooler
          tag="M-2701AB"
          x={810}
          y={170}
          rpm={1500}
          size={45}
          bladeCount={7}
          bladeLength={30}
        onClick={() => openCoolerPanel("M-2701AB")}    />
      
     
        <AirCooler
          tag="M-2701BA"
          x={775}
          y={295}
          rpm={1500}
          size={45}
          bladeCount={7}
          bladeLength={30}
        onClick={() => openCoolerPanel("M-2701BA")}    />
      
     
        <AirCooler
          tag="M-2701BB"
          x={810}
          y={295}
          rpm={1500}
          size={45}
          bladeCount={7}
          bladeLength={30}
        onClick={() => openCoolerPanel("M-2701BB")}    />
      
     

                


    </div>
  );
}


export default TEGReboiler;